//使用格式说明：
//1、带参数：已更新{parm}讲，参数位置可以调整，ag:Updated Lecture {parm}
const kh = {
    public: {
        moneyUnit:' ដុល្លារ',
        nodata: 'គ្មានទិន្នន័យ',
        share:"ចែករំលែក",
        orderNumber:"លេខបញ្ជារទិញ",
        remark:"សម្គាល់",
        save:"រក្សារទុក",
        vcode:"វាយបញ្ចូលលេខកូដ",
        getCode:"ទទួលលេខកូដ",
        inputPhone:"បញ្ចូលលេខទូរស័ព្ទ",
        detail:"អំពីសៀវភៅ",
        hour:"ម៉ោង",
        minute:"នាទី",
        second:"វិនាទី",
        again:'{parm} វិនាទី',
        sex_1:"ប្រុស",
        sex_2:"ស្រី",
        sex_3:"សម្ងាត់",
        payTitle:'បញ្ចូលលេខកូដបង់ប្រាក់',
        payMethod:'វិធីទូទាត់ប្រាក់',
        paySmall :'ទឹកប្រាក់',
        cancel :'បោះបង់',
        send:'បានផ្ញើទៅកាន់៖',
        verifyId:'បញ្ជាក់អត្តសញ្ញាណ',
        loginRegister:'បង្កើតគណនី / ចូលគណនី ',
        looking:'មើលលេងៗ',
        selectArea:'សូមជ្រើសរើសលេខកូដប្រទេស',
        contactus:'ការតភ្ជាប់',
        pageViews:"{parm} បើកមើល",
        pageViews_1:"បើកមើល {parm}",
        rebate:"{parm}ដងឡើងលើ",
        ok:'យល់ព្រម',
        get:'{parm} 获得 {parm_1}',
        close:'关闭'
    },
    pull:{
        loading:'កំពុងដំណើរការ...',
        swipe:'ទាញចុះក្រោម',
        release:'សូមរងចាំ'
    },
    tabbar:{
        home:'ទំព័រដើម',
        assort:'商城',
        points:'仓库',
        topic:'អត្ថបទ',
        mine:'គណនី'
    },
    index: {
        key_1:'最高优惠$',
        key_2:'限时优惠{parm}%oFF',
        key_4:'我知道了',
        key_6:'券后',
        key_7:'部分盒子可用',
        key_8:'全部盒子可用',
        key_9:'满${parm}可用',
        key_10:'满${parm} 部分盒子可用',
        key_11:'满${parm} 全部盒子可用',
        key_12:'立即领取',
        key_13:'去使用',
        key_14:'全部领取',
        key_15:'明天再来',
        key_16:'立即参与',
        key_17:'选择优惠券',
        key_18:'无门槛',
        key_20:'有效期至{parm}',
        key_21:'确定订单',
        key_22:'{parm}张可用',
        key_23:'优惠券',
        key_24:'连抽优惠',
        key_25:'共计优惠:',
        key_26:'立即支付',
        key_27:'用户服务协议及隐私政策',
        key_28:'支付提醒',
        key_29:'支付成功费用将从零钱中减除，继续请点确定支付',
        key_30:'确定支付',
        key_31:'立即开盒'
    },
    boxdetail:{
        key_1:'100%必中价值',
        key_2:'真实概率/必中无空包/三件包邮/正品保障',
        key_3:'点击查看全部',
        key_4:'谢绝未成年人使用或在监护人的监督指导下体验',
        key_5:'分享有奖',
        key_6:'商品详情',
        key_7:'开盒必出以下宝贝之一',
        key_8:'共{parm}款({parm_1}个{parm_2})'/* 共10款(10个传说/史诗) */
    },
    box:{
        key_1:'去仓库',
        key_2:'再来一发',
        key_3:'可兑换:',
        key_4:'币',
        key_5:'提示:请在<i>{parm}</i>前提货,过期将不再提货，只能兑换',
        key_6:'兑换',
        key_7:'提货',
        key_8:'商品',
        key_9:'盲盒',
        key_10:'去开盒',
        key_11:'<p>兑换需知</p><p>1.获得商品可以兑换成币服务</p><p>2.兑换成功的币可用于商城产品兑换</p><p>3.币兑换成功不可逆转，不可转让，不可提现</p><p>4.币最终解析权归平台所有，有疑问请联系客服</p>',
        key_12:'共{parm}件',
        key_13:'合计:',
        key_14:'立即兑换',
        key_15:'兑换提醒',
        key_16:'兑换币后不可逆转，请确定是否兑换？',
        key_18:'兑换成功',
        key_19:'获得{parm}币',
        key_20:'返去仓库',
        key_21:'去调选商品',
        key_22:'确定订单',
        key_23:'请添加收件地址',
        key_24:'配送方式',
        key_25:'免运费',
        key_26:'优惠券',
        key_27:'没有优惠券',
        key_28:'订单备注',
        key_29:'可给商家留言',
        key_30:'提交订单',
        key_31:'仓库没有适合的商品！',
        key_32:'提货提醒',
        key_33:'提货后会生成待发货订单，可在订单中心查看，继续请点击确定？',
        key_34:'成功创建提货订单！',
        key_35:'选择要提货的商品',
        key_36:'全选',
        key_37:'已选择<i>{parm}</i>件',
        key_38:'立即提货'

    },
    mall:{
        key_1:'我的货币',
        key_2:'全部',
        key_3:'{parm}以上',
        key_4:'客服',
        key_5:'直接购买',
        key_6:'立即兑换',
        key_7:'库存:',
        key_8:'购买数量',
        key_9:'(每人限购{parm}件)',
        key_10:'立即购买',
        key_11:'请选择好规格',
        key_12:'确定订单',
        key_13:'请添加收件地址',
        key_14:'配送方式',
        key_15:'免运费',
        key_16:'优惠券',
        key_17:'没有优惠券',
        key_18:'订单备注',
        key_19:'可给商家留言',
        key_20:'共{parm}件',
        key_21:'合计:',
        key_22:'支付订单',
        key_23:'支付成功将从积分中扣除',
        key_24:'支付成功将从零钱中扣除费用',
        key_25:'继续请点击确定？',
        key_26:'支付成功！',
        key_27:'我的订单',
        key_28:'订单号:',
        key_29:'删除订单',
        key_30:'订单详情',
        key_31:'全部',
        key_32:'待付款',
        key_33:'待发货',
        key_34:'待收货',
        key_35:'已完成',
        key_36:'删除提醒',
        key_37:'确定删除订单，继续请点击确定？',
        key_38:'付款方式',
        key_39:'兑换币',
        key_40:'订单编号',
        key_41:'下单时间',
        key_42:'付款时间',
        key_43:'发货时间',
        key_44:'完成时间',
        key_45:'买家留言',
        key_46:'确认收货',
        key_47:'收货提醒',
        key_48:'在确保真实收到货后再点击收货，继续请点击确定？',
        key_49:'已确定收货！',
        key_50:'已删除',
        key_51:'综合',
        key_52:'价格',
        key_53:'币',
    },
    coupon:{
        key_1:"优惠券",
        key_2:"无门槛",
        key_3:'满${parm}可用',
        key_4:"有效期至 {parm}",
        key_5:"去使用",
        key_6:"未使用",
        key_7:"已使用",
        key_8:"已过期",
    },
    address:{
        key_1:"地址管理",
        key_2:"设为默认",
        key_3:"编辑",
        key_4:"删除",
        key_5:"添加地址",
        key_6:"操作提示",
        key_7:"删除地址不可逆转操作，继续请点击确定？",
        key_8:"编辑地址",
        key_9:"收件人：",
        key_10:"请输入联系姓名",
        key_11:"手机号：",
        key_12:"请输入联系手机",
        key_13:"所在地区：",
        key_14:"详细地址：",
        key_15:"默认地址："

    },
    about:{
        key_1:"អំពីយើង",
        key_2:"កម្មវិធី",
        key_3:"តំឡើងកម្មវិធី",
        key_4:"កម្មវិធីនេះជាកម្មវិធីចុងក្រោយបំផុតហើយ"
    },
    account:{
        key_1:"គណនីខ្ញុំ",
        key_2:"ផ្ទេរប្រាក់",
        key_3:"ទឹកប្រាក់នៅសល់",
        key_4:"បញ្ចូល",
        key_5:"លម្អិត",
        key_6:"ដកប្រាក់",
        key_7:"ប្រវត្តិដកប្រាក់",
        key_9:"ប្រវត្តិចំណូល",
        key_10:"ចំណូល",
        key_11:"ថ្ងៃនេះ",
        key_12:"ខែនេះ",
        key_13:"ខែមុន",
        key_14:'上拉获得更多记录'
    },
    bindphone:{
        key_1:"តភ្ជាប់លេខទូរស័ព្ទ",
        key_2:"ទូរស័ព្ទចាស់",
        key_3:"ទូរស័ព្ទថ្មី",
        key_4:"ដូរ",
        key_5:"លេខទូរស័ព្ទ",
        key_6:"ដូរលេខទូរស័ព្ទមិនប៉ះពាល់ដល់ការប្រើប្រាស់សិទ្ធិសមាជិកភាព VIP និងទឹកប្រាក់ក្នុងគណនីអ្នកទេ ",
        key_7:"បញ្ចូលលេខទូរស័ព្ទថ្មី",
        key_8:"ដូរលេខទូរស័ព្ទ",
        key_9:"គណនីនេះមានរួចហើយ",
        key_10:"ដូរលេខទូរស័ព្ទថ្មី ឬទាក់ទងក្រុមការងារដើម្បីដូរជូន ",
        key_11:"បញ្ចូលលេខកូដដែលផ្ញើរទៅលេខទូរស័ព្ទអ្នក ",

    },
    cPassword:{
        key_1:"លេខសម្ងាត់",
        key_2:"លេខសម្ងាត់ចាស់",
        key_3:"បញ្ចូលលេខសម្ងាត់ចាស់",
        key_4:"លេខសម្ងាត់ថ្មី",
        key_5:"វាយម្តងទៀត",
        key_6:"សូមវាយបញ្ចូលលេខសម្ងាត់ថ្មី",
        key_7:'密码为8~20位，需包含数字与字母',
        key_8:"请输入密码",
        key_9:'请再次输入密码',
    },
    editname:{
        key_1:"កែឈ្មោះ",
        key_2:"វាយបញ្ចូលឈ្មោះ",
        key_3:"សូមវាយបញ្ចូលឈ្មោះអ្នក",
    },
    help:{
        key_1:"ជំនួយ"
    },
    incomedetail:{
        key_1:"សាច់ប្រាក់លម្អិត",
        key_2:"ប្រាក់ចូលគណនី",
        key_3:"ប្រាក់ចេញពីគណនី",
        key_4:"ប្រភេទ",
        key_5:"ចំណូល",
        key_6:"ចំណាយ",
        key_7:"រយះពេល",
        key_8:"លេខប្រតិបត្តិការ",
        key_9:"ចំនួនទឹកប្រាក់",
        key_10:"បញ្ជាក់"
    },
    invite:{
        key_1:"ប្រវត្តិ",
        key_2:"រូបភាព",
        key_3:"ផ្ញើទៅកាន់មិត្តភក្តិឥឡូវនេះ",
        key_4:"ជោគជ័យ"
    },
    login:{
        key_1:"ចុះឈ្មោះ",
        key_2:"ចូលដោយប្រើលេខសម្ងាត់",
        key_3:"បញ្ចូលលេខសម្ងាត់",
        key_4:"ភ្លេចលេខសម្ងាត់",
        key_5:"ខ្ញុំបានអាន និងយល់ព្រម",
        key_6:"លក្ខខណ្ឌក្នុងការប្រើប្រាស់",
        key_7:"ចូលគណនី",
        key_8:"បញ្ចូលលេខទូរស័ព្ទ",
        key_9:"បញ្ចូលលេខសម្ងាត់",
        key_10:"សូមរងចាំ...",
        key_11:"លេខកូដណែនាំ",
        key_12:"ធ្លាប់មានគណនីហើយ? ចូលទីនេះ",
        key_13:"យល់ព្រមចុះឈ្មោះ",
        key_14:"កំពុងចុះឈ្មោះ",
        key_15:"កំពុងដំណើការ",
        key_16:"កែលេខសម្ងាត់",
    },
    mine:{
        key_1:"登录/注册账户",
        key_2:"编辑资料",
        key_3:"我的零钱",
        key_4:"我的币",
        key_5:"商品",
        key_6:"盲盒",
        key_7:"我的应用",
        key_8:"优惠券",
        key_9:"地址管理",
        key_10:"帮助中心",
        key_11:"邀请有奖",
        key_12:"签到领盲盒",
        key_13:"我的订单",
        key_14:"全部订单",
        key_15:"待付款",
        key_16:"待发货",
        key_17:"待收货",
        key_18:"已完成",
    },
    notice:{
        key_1:"ព័ត៌មាន",
        key_2:"ព័ត៌មានផ្សេងៗ",
        key_3:"បានអានទាំងអស់",
        key_4:"ចុចមើល"
    },
    recharge:{
        key_1:"បញ្ចូលប្រាក់",
        key_2:"បញ្ជាក់៖ សូមបញ្ចូលវិក័យបត្រផ្ញើរប្រាក់ ក្រោយពេលផ្ទេរប្រាក់រួចរាល់",
        key_3:"ចំនួនទឹកប្រាក់",
        key_4:"ផ្ទេរតាមវីងវេរលុយ និងធនាគារផ្សេងទៀត",
        key_5:"បញ្ជូន",
        key_6:"ត្រូវការជំនួយសូមទាក់ទងមកកាន់ក្រុមការងារតាមរយៈ",
        key_7:"សូមបញ្ចូលវិក័យបត្រផ្ញើរប្រាក់",
        key_8:" វិក័យបត្រ",
        key_9:"ផ្ទេរទៅកាន់គណនី",
        key_10:"ACLEDA",
        key_11:"ABA",
        key_12:"WING"
    },
    setPaypaswd:{
        key_1:"កំណត់លេខកូដបង់ប្រាក់",
        key_2:"លេខកូដបង់ប្រាក់",
        key_3:"បញ្ចូលលេខសម្ងាត់ថ្មី",
        key_4:"លេខទូរស័ព្ទ",
        key_5:"កំណត់លេខកូដបង់ប្រាក់",
        key_6:"សូមចុច 'កំណត់' ឬ ចូលទៅកាន់ 'គណនីខ្ញុំ'-->'ពត៌មានផ្ទាល់ខ្លួន'-->'លេខកូដបង់ប្រាក់' ដើម្បីកំណត់លេខកូដបង់ប្រាក់6ខ្ទង់។",
        key_7:"កំណត់",
        key_8:"បោះបង់",
        key_9:"កំណត់លេខកូដបង់ប្រាក់"
    },
    setting:{
        key_1:"个人信息",
        key_2:"个人头像",
        key_3:"姓名",
        key_4:"性别",
        key_5:"修改密码",
        key_6:"修改",
        key_7:"绑定手机",
        key_8:"已绑定",
        key_9:"未绑定",
        key_10:"支付密码",
        key_11:"已设置",
        key_12:"未设置",
        key_13:"退出登录",
        key_14:"性别设置",
        key_15:"设置",
        key_16:"关于我们",
        key_17:"语言设置",
        key_18:"账户与安全",
        key_19:"退出提示",
        key_20:"您在正尝试退出登录，继续请点击确定？",
    },
  
    transfer:{
        key_1:"ផ្ទេរប្រាក់",
        key_2:"បញ្ជាក់៖ ពេលផ្ទេរប្រាក់រួច សូមបញ្ចូលវិក័យបត្រផ្ទេរប្រាក់",
        key_3:"លេខទូរស័ព្ទអ្នកទទួល",
        key_4:"បញ្ជាក់",
        key_5:"ចំនួនទឹកប្រាក់",
        key_6:"ប្រាក់នៅសល់ៈ ",
        key_7:"ផ្ទេរទាំងអស់",
        key_8:"ផ្ទេរប្រាក់",
        key_9:"មានចម្ងល់អាចទាក់ទងលេខទូរស័ព្ទ 093808833",
        key_10:"សូមវាយបញ្ចូលលេខគណនីអ្នកទទួលនិងចំនួនទឹកប្រាក់ត្រូវផ្ទេរ"
    },

    withdraw:{
        key_1:"ដកប្រាក់",
        key_2:"ចំនួន",
        key_3:"ប្រាក់នៅសល់",
        key_4:"ដកទាំងអស់",
        key_5:"ស្នើសុំ",
        key_6:"ឈ្មោះធនាគារ",
        key_7:"លេខគណនី",
        key_8:"ឈ្មោះអ្នកទទួល",
        key_9:"ព័ត៌មានអ្នកទទួល",
        key_10:"គណនីធនាគារ",
        key_11:"ពិនិត្យក្នុងរយៈពេល24ម៉ោង",
        key_12:"សូមធ្វើការភ្ជាប់គណនីធនាគារជាមុនសិន",

    },
    integral:{
        title:"ផ្សារ",
        key_1:"ប្រភេទ",
        key_2:"លក់បាន {parm}",
        key_3:"នៅសល់ {parm}",
        key_4:"អ្នកមើល",
        key_5:"លម្អិត",
        key_6:"ដូរ",
        key_7:"រង្វាន់",
        key_8:"គោលការណ៍",
        key_9:"ពិន្ទុខ្ញុំ",
        key_10:"VIP ខ្ញុំ",
        key_11:"ពិន្ទុ",
        key_12:"ចាប់ផ្តើមឥឡូវនេះ",
        key_13:"ទាញយក",
        key_14:"ស្អែកមកផ្តងទៀត",
        key_15:" អបអរសាទរ អ្នកទទួលបាន",
        key_16:" ដូរយកទំនិញ",
        key_17:" រង់ចាំផ្ញើរ",
        key_18:" បានផ្ញើរ",
        key_19:" លេខបញ្ជារទិញ",
        key_20:" សរុប",
        key_21:" លម្អិត",
        key_22:" លេខបញ្ជារទិញ",
        key_23:" ពេលបញ្ជារទិញ",
        key_24:" ពេលប្តូរ",
        key_25:" សរុប {parm}",
        key_26:" ប្តូរពិន្ទុ",
        key_27:" គណនា",
        key_28:" របៀបបង់ប្រាក់",
        key_29:" ទូទាត់ប្រើពិន្ទុ",
        key_30:" សរុប",
        key_31:" ប្តូរ",
        key_32:" ការបង្ហាញ",
        key_33:" ក្រោយពេលប្តូរហើយនឹងកាត់ពិន្ទុ សូមចុច បន្ត",
        key_34:" បន្ត",
        key_35:" ពិន្ទុលម្អិត",
        key_36:" ពិន្ទុអាចប្រើបាន",
        key_37:" ទទួលពិន្ទុ",
        key_38:" កំណត់ត្រា",
        key_39:" បានកត់វត្តមាន <i>{parm}</i> ថ្ងៃហើយ",
        key_40:" ទៅកត់វត្តមាន",
        key_41:" ផលិតផលចុងក្រោយ",
        key_42:"ចូលហាង",
    },
    transferpoints:{
        title:"លុយប្តូរយកពិន្ទុ",
        key_1:" ចំនួន",
        key_2:" ប្តូរទាំងអស់",
        key_3:" យល់ព្រមប្តូរ",
        key_4:" វាយបញ្ចូលចំនួនត្រូវប្តូរ",
        key_5:" បញ្ជាក់",
        key_6:" ប្តូរហើយ មិនអាចប្តូរត្រឡប់វិញបានទេ សូមចុច យល់ព្រម ដើម្បីបន្ត",
        key_7:" បញ្ជាក់៖ អត្រាប្តូរពេលនេះ<i class='ratio'>1:{parm}</i> ប្តូរហើយ មិនអាចប្តូរត្រឡប់វិញបានទេ"
        
    }


    

}
 
export default kh


// WEBPACK FOOTER //
// ./src/lang/pack/kh.js